import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
        >
          <path d="M14.438 13.992H13.25a1.189 1.189 0 01-1.188-1.187V2.117c0-.655.533-1.187 1.188-1.187h1.188c.654 0 1.187.532 1.187 1.187v10.688c0 .655-.533 1.187-1.188 1.187zM13.25 2.117v10.688h1.188V2.117H13.25zM9.687 13.992H8.5a1.189 1.189 0 01-1.188-1.187V6.867c0-.655.533-1.187 1.188-1.187h1.188c.654 0 1.187.532 1.187 1.187v5.938c0 .655-.533 1.187-1.188 1.187zM8.5 6.867v5.938h1.188V6.867H8.5zm-3.563 7.125H3.75a1.189 1.189 0 01-1.188-1.187V4.492c0-.655.533-1.187 1.188-1.187h1.188c.654 0 1.187.532 1.187 1.187v8.313c0 .655-.533 1.187-1.188 1.187zm-1.187-9.5v8.313h1.188V4.492H3.75zm13.063 11.281a.594.594 0 00-.594-.593H1.969a.595.595 0 01-.594-.594V1.523a.594.594 0 00-1.188 0v13.063c0 .982.8 1.781 1.782 1.781h14.25a.594.594 0 00.593-.594z"></path>
        </svg>
    );
}